import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Grid,
  Button,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadIcon from "@mui/icons-material/Download";
import { FooterInfo } from "./footer-info";
import FileDropZone from "./drag-n-drop";

export default function BulkBusinessModal({ open, onClose }) {
  console.log(open);
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const values = Object.fromEntries(formData.entries());

    console.log(values);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6">Bulk Business Upload</Typography>

        <Typography variant="body2" color="text.secondary">
          Upload multiple businesses at once using a CSV file
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            width: "100%",
            backgroundColor: "rgba(0,0,0,0.1)",
            padding: "10px 10px",
            borderRadius: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DescriptionIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              Standard size only • CSV / Excel • Max 24KB
            </Typography>
          </Box>

          <Button
            size="small"
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={(f) => f}
            sx={{
              textTransform: "none",
              borderRadius: "4px",
            }}
          >
            Download Template
          </Button>
        </Stack>
        <Box sx={{ margin: "40px 0" }}>
          <FileDropZone />
        </Box>
        <FooterInfo>
          Our system will automatically perform a real-time validation of tax
          IDs and registered names against the national database.
        </FooterInfo>
      </DialogContent>

      <DialogActions sx={{ backgroundColor: "rgba(0,0,0,0.2)" }}>
        <Button sx={{ color: "#000" }} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          type="submit"
          form="business-form"
          sx={{ boxShadow: "0" }}
        >
          Register Business
        </Button>
      </DialogActions>
    </Dialog>
  );
}
